import { render, staticRenderFns } from "./bloc-global.vue?vue&type=template&id=1676e42b"
import script from "./bloc-global.vue?vue&type=script&lang=js"
export * from "./bloc-global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports